import EventEmitter from "../../utils/eventEmitter";
import Axios from "../utils/axios"


export const loadWarehouses = async () => {
  try {
    const response = await Axios.get('warehouses');
    const responseData = await response.data;
    return responseData;
  }catch (err) {
    throw err;
  }
};

const loadOneWarehouse = async (name) => {
  try {
    const respnse = await Axios.get('warehouses/'+name);
    const responseData = await respnse.data;
    return responseData;
  }catch (err) {
    throw err;
  }
}

export const loadWarehouse = async (action) => {
  try {
    switch (action) {
      case 'new':
        return [];
        
      default:
        const data = await loadOneWarehouse(action);
        return data;
    }
  }catch (err) {
    throw err;
  }
}

const useWarehouseAPI = () => {
  
  const create = async (data, success) => {
    try {
      const respnse = await Axios.post('warehouses/v1_2/create', data);
      const responseData = await respnse.data;
      success(responseData.message);
      EventEmitter.dispatch('wareshouse_response', data.seo);
    }catch(err) {
      throw err;
    }
  }

  const update = async (seo, data, success) => {
    try {
      const respnse = await Axios.put('warehouses/'+seo, data);
      const responseData = await respnse.data;
      success(responseData.message);
    }catch (err) {
      throw err;
    }
  }


  return { create, update };
};



export default useWarehouseAPI;


